module.exports = __webpack_public_path__ + "img/7.8245c604.jpg";